import React from 'react'; 
import Irrigation_Hero from '../components/Irrigation_Hero';
import Water from '../components/Water';
import Navbar from '../components/Navbar';

export default function Soil() {

    return (
        <div>
            <Navbar/>
           <Water />
        </div>
    )
}
